import { InfoChip } from '@components/InfoChip';
import { IconMessageRead, IconCheck, IconDoneAll } from '@components/icons';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const InfoChipSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Info Chip"
      description="A pill-shaped chip component for displaying status information with optional icons. Supports multiple semantic color variants."
      figmaNodeId="616-6450"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>All Variants</h3>
      <div className={styles.infoChipRow}>
        <InfoChip
          label="Contacted"
          type="primary"
          icon={<IconMessageRead size={20} />}
        />
        <InfoChip
          label="Contacted"
          type="text"
          icon={<IconMessageRead size={20} />}
        />
        <InfoChip
          label="Contacted"
          type="info"
          icon={<IconMessageRead size={20} />}
        />
        <InfoChip
          label="Contacted"
          type="warning"
          icon={<IconMessageRead size={20} />}
        />
        <InfoChip
          label="Contacted"
          type="success"
          icon={<IconMessageRead size={20} />}
        />
        <InfoChip
          label="Contacted"
          type="danger"
          icon={<IconMessageRead size={20} />}
        />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Without Icon</h3>
      <div className={styles.infoChipRow}>
        <InfoChip label="Primary" type="primary" showIcon={false} />
        <InfoChip label="Text" type="text" showIcon={false} />
        <InfoChip label="Info" type="info" showIcon={false} />
        <InfoChip label="Warning" type="warning" showIcon={false} />
        <InfoChip label="Success" type="success" showIcon={false} />
        <InfoChip label="Danger" type="danger" showIcon={false} />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Different Icons</h3>
      <div className={styles.infoChipRow}>
        <InfoChip
          label="Verified"
          type="success"
          icon={<IconCheck size={20} />}
        />
        <InfoChip
          label="Complete"
          type="primary"
          icon={<IconDoneAll size={20} />}
        />
        <InfoChip
          label="Message Read"
          type="info"
          icon={<IconMessageRead size={20} />}
        />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Use Cases</h3>
      <div className={styles.infoChipRow}>
        <InfoChip label="Contacted" type="primary" icon={<IconMessageRead size={20} />} />
        <InfoChip label="Pending" type="warning" showIcon={false} />
        <InfoChip label="Approved" type="success" icon={<IconCheck size={20} />} />
        <InfoChip label="Rejected" type="danger" showIcon={false} />
      </div>
      <p className={styles.hint}>
        Use different types to convey semantic meaning: primary for neutral/active, info for informational, warning for attention, success for positive, danger for negative outcomes.
      </p>
    </div>
  </section>
);
